export class Plugin {
  constructor(http) {
    this.http = http;
  }

  fetchPlugin(startDate, endDate) {
    return this.http
      .get('plugin', { params: { startDate, endDate } })
      .then(response => normalizePlugin(response.data));
  }
}

function normalizePlugin(response) {
  const days = new Set();
  const users = Object.keys(response);
  const normalizedResponse = {};

  users.forEach(userId => {
    normalizedResponse[userId] = [];
    Object.keys(response[userId]).forEach(day => {
      days.add(day);
    });
  });

  // flatten
  days.forEach(day => {
    Object.keys(response).forEach(userId => {
      normalizedResponse[userId].push({ ...response[userId][day], day });
    });
  });

  return { users, data: normalizedResponse };
}
